// Imports
import * as Sentry from '@sentry/browser';


/** Resizes blog gallery images to the same height while preserving aspect ratios */
export default function sizeGalleryImages(element: HTMLElement) {
	// Iterate through every blog gallery image
	for (const image of element.querySelectorAll('.kg-gallery-image > img')) {
		// Determine the image's intrinsic dimensions
		const width = Number(image.getAttribute('width'));
		const height = Number(image.getAttribute('height'));
		
		
		// Report images that cannot be resized and therefore will cause an uneven layout
		if (!image.parentElement || !Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) {
			Sentry.captureMessage(
				`Blog gallery image is missing usable width/height attributes: ${image.getAttribute('src') ?? 'unknown source'}`,
				'error'
			);
			
			continue;
		}
		
		
		// Size the container by the image's aspect ratio
		image.parentElement.style.flexGrow = String(width / height);
	}
}
